import { render } from "./ViewMyStatsMatch.vue?vue&type=template&id=291875cb&scoped=true"
import script from "./ViewMyStatsMatch.vue?vue&type=script&lang=js"
export * from "./ViewMyStatsMatch.vue?vue&type=script&lang=js"

import "./ViewMyStatsMatch.vue?vue&type=style&index=0&id=291875cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291875cb"]])

export default __exports__